import React from 'react'

const Buynow = () => {
  return (
    <div>
      <h1>Buy Now page</h1>
    </div>
  )
}

export default Buynow
